"use client"

import { useRouter } from "next/navigation"
import { X, ArrowRight } from "lucide-react"
import { cn } from "@/lib/utils"

interface PhoneVerificationGateProps {
  onVerifiedAction: () => void
  onCloseAction?: () => void
  dimBackground?: boolean
}

export function PhoneVerificationGate({ onVerifiedAction, onCloseAction, dimBackground = true }: PhoneVerificationGateProps) {
  const router = useRouter()

  return (
    <div
      className={cn(
        "fixed inset-0 z-100 flex items-center justify-center px-4",
        dimBackground ? "bg-black/60 backdrop-blur-xs" : "bg-transparent"
      )}
    >
      {onCloseAction && (
        <button
          type="button"
          aria-label="Close"
          onClick={onCloseAction}
          className="absolute top-4 right-4 z-101 flex h-10 w-10 items-center justify-center rounded-full bg-background/10 hover:bg-background/20 active:bg-background/30 transition-colors duration-150 focus:outline-hidden focus-visible:ring-2 focus-visible:ring-white/60"
        >
          <X className="h-5 w-5 text-white" />
        </button>
      )}
      
      <div className="text-center space-y-4">
        <p className="text-amber-300 text-lg font-bold">Verify your phone</p>
        <p className="text-amber-300/80 text-sm">This is to ensure everybody's safety</p>
        <button
          onClick={() => router.push("/verify-phone")}
          className="group px-3 py-1.5 bg-transparent hover:bg-muted/50 text-amber-300 hover:text-amber-500 text-sm rounded-full transition-all duration-200 font-medium flex items-center gap-1.5 border border-amber-300 hover:border-amber-500 mx-auto"
        >
          Verify Phone
          <ArrowRight className="h-3 w-3 text-amber-300 group-hover:text-amber-500 transition-all duration-200 group-hover:translate-x-0.5" />
        </button>
      </div>
    </div>
  )
}

